import React, { useEffect } from 'react';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Helmet } from 'react-helmet';
import { useReactlytics } from '@americanexpress/reactlytics';
import { composeModules } from 'holocron';
import { getSelectedProduct, getProductsByTypes } from 'axp-product-ducks';
import GermanyJourney from './GermanyJourney';
import Product from './Product';
import Spinner from './Common/Spinner';
import ErrorPageProvider from './Common/ErrorPageProvider';
import { createAnalyticsData } from '../utils';

export const AxpApplySupplementaryCardGermany = ({
  languageData,
  inAuthId,
  selectedProduct,
  productsList,
  host,
  locale,
  location: { query: { sourcecode } },
}) => {
  const languageDataForLibrary = { ...languageData };
  delete languageDataForLibrary.links;
  const { track } = useReactlytics();
  useEffect(() => {
    track(createAnalyticsData({
      element: 'SuppApp',
    }));
  });

  const renderApp = () => {
    if (!productsList || Object.keys(productsList).length === 0) {
      return (
        <Spinner />
      );
    }
    return (
      <IntlProvider locale={locale} messages={languageData}>
        <ErrorPageProvider
          host={host}
          track={track}
        >
          <Product
            locale={locale}
            host={host}
            selectedProduct={selectedProduct}
            productsList={productsList}
            inAuthId={inAuthId}
            sourcecode={sourcecode}
          >
            <GermanyJourney host={host} />
          </Product>
        </ErrorPageProvider>
      </IntlProvider>
    );
  };

  return (
    <>
      {renderApp()}
      <Helmet
        link={[
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.3/package/dist/6.25.3/styles/dls.min.css',
          },
        ]}
      >
        <style type="text/css">{`
          .pingFangFonts {
            font-family: "PingFang SC" !important;
          }
          .notoFonts {
            font-family: "Noto Sans JP" !important;
          }
          .btnFontSize{
            font-size:3.875rem !important
          }
          .btnMaxWidth{
            max-width:763px !important
          }
          .btnMinWidth{
            min-width:20.625rem !important
          }
          .btnHeight{
            min-width:20.625rem !important
            height:3.125rem !important
          }
          .bybAnchor {
            display: inline!important
          }
          
        `}
        </style>
      </Helmet>
    </>
  );
};

export const loadModuleData = async ({ store }) => {
  const { dispatch } = store;
  await dispatch(loadLanguagePack('axp-apply-supplementary-card-germany', { fallbackLocale: 'de-de' }));
  await dispatch(composeModules([
    { name: 'axp-card-selector' },
  ]));
};

AxpApplySupplementaryCardGermany.holocron = {
  name: 'axp-apply-supplementary-card-germany',
  loadModuleData,
};

AxpApplySupplementaryCardGermany.propTypes = {
  languageData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  locale: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.shape({
      sourcecode: PropTypes.string,
    }),
  }).isRequired,
  inAuthId: PropTypes.string,
  selectedProduct: PropTypes.string,
  productsList: PropTypes.objectOf(PropTypes.object),
  host: PropTypes.string.isRequired,
};

AxpApplySupplementaryCardGermany.defaultProps = {
  inAuthId: undefined,
  productsList: undefined,
  selectedProduct: undefined,
};

/* istanbul ignore next */
export const mapStateToProps = (state) => ({
  host: state.getIn(['config', 'acquisitionSuppPslApiUrl']),
  inAuthId: state.getIn(['modules', 'axp-card-member-apply-root', 'query', 'inAuthUUID']),
  locale: state.getIn(['intl', 'activeLocale']),
  selectedProduct: getSelectedProduct(state),
  productsList: getProductsByTypes(state),
});

const hocChain = compose(
  oneAppModuleWrapper('axp-apply-supplementary-card-germany'),
  connect(mapStateToProps)
);

export default hocChain(AxpApplySupplementaryCardGermany);
